import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { PHONE, TEL, LOGO } from "./shared";

const links = [
  { label: "Services", href: "#services" },
  { label: "Our Work", href: "#our-work" },
  { label: "RV Cleaning", href: "#rv-cleaning" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Reviews", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl shadow-[0_2px_20px_rgba(43,81,86,0.06)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <img
            src={LOGO}
            alt="Tanya's Cleaning logo"
            className="w-12 h-12 rounded-full object-contain bg-white ring-1 ring-blush p-0.5 group-hover:ring-pink transition-all duration-300"
          />
          <span className="font-serif-display text-2xl text-teal leading-none">
            Tanya&apos;s Cleaning
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-teal-soft hover:text-teal transition-colors relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-pink hover:after:w-full after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={TEL}
          data-testid="header-call-button"
          className="hidden md:inline-flex items-center gap-2 bg-teal text-white hover:bg-teal-dark rounded-full px-6 py-3 text-sm transition-all duration-300 shadow-md hover:shadow-lg"
        >
          <Phone size={16} strokeWidth={1.5} /> {PHONE}
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-teal"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-blush px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-teal-soft hover:text-teal text-lg"
            >
              {l.label}
            </a>
          ))}
          <a href={TEL} className="mt-2 inline-flex items-center justify-center gap-2 bg-teal text-white rounded-full px-6 py-3">
            <Phone size={16} strokeWidth={1.5} /> {PHONE}
          </a>
        </div>
      )}
    </header>
  );
}
